@if (useFrame) {
  @if (page) {
    <div class="background"></div>
    <div class="foreground">
      <tyt-host
        [path]="page.url"
        [consumeNavigation]="true"
        />
    </div>
  } @else {
    <app-spinner />
  }
} @else {
  @if (page && user?.staff) {
    <div class="editor-toolbar">
      <span class="status-tag">{{ page.is_published ? 'Published' : 'Draft' }}</span>
      <mat-checkbox [(ngModel)]="editorSync" matTooltip="Preview editor changes live">Preview</mat-checkbox>
      <a mat-icon-button color="primary" routerLink="/pages/edit/{{page?.id}}" matTooltip="Open Editor">
        <mat-icon>edit</mat-icon>
      </a>
    </div>
  }

  <div class="background"></div>
  <div class="foreground">
    @if (page) {
      @if (user?.staff) {
        <div class="editor-tools">
          <tyt-deferred [component]="simulatorComponent" [inputs]="{ changed: overridesChanged }" />
        </div>

        @if (editorSync && !syncMessageDismissed) {
          <div class="alert alert-info with-icon">
            <mat-icon>info</mat-icon>
            <div>
              <strong>Previewing unsaved edits in real time.</strong>
              <p>This view shows unsaved changes made in the page editor in real time. You can keep this page open in
                another tab or on another screen to quickly preview your changes.
              </p>
              <div class="action-buttons">
                <a mat-raised-button color="primary" routerLink="/pages/edit/{{page?.id}}">
                  <mat-icon>edit</mat-icon>
                  Edit Page
                </a>
                <button mat-button (click)="syncMessageDismissed = true">
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        }
        @if (!editorSync) {
          @if (!page.is_published && !unpublishMessageDismissed) {
            <div class="alert alert-warning with-icon">
              <mat-icon>warning</mat-icon>
              <div>
                <strong>This content is not published.</strong>
                <p>This page has not yet been published. Only TYT.com staff can view it.</p>
                <div class="action-buttons">
                  <a mat-raised-button color="primary" routerLink="/pages/edit/{{page?.id}}">
                    <mat-icon>edit</mat-icon>
                    Edit Page
                  </a>
                  <button mat-button (click)="unpublishMessageDismissed = true">
                    Dismiss
                  </button>
                </div>
              </div>
            </div>
          }
        }
      }

      @if (!refreshing) {
        <div class="cms-page">
          <tyt-content-view [blocks]="ContentTypes.contentBlocksFromApi(page?.blocks)"></tyt-content-view>
        </div>
      }
    }
    @if (user?.staff) {
      <div class="actions">
        <a routerLink="/pages/edit/{{page?.id}}">Edit Page</a>
      </div>
    }
  </div>
}